<template>
  <div class="page-template" v-loading="loading">
<!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="商品毛利" name="goodsGrossMargin">
        <search-form-template
          :searchOptions="goodsGrossMarginSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelGoodsGrossMargin()"
        ></search-form-template>
        <table-template ref="goodsGrossMargin" :tableOptions="goodsGrossMarginTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="类别毛利" name="categoryGrossMargin">
        <search-form-template
          :searchOptions="categoryGrossMarginSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelCategoryGrossMargin()"
        ></search-form-template>
        <table-template ref="categoryGrossMargin" :tableOptions="categoryGrossMarginTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="品牌毛利" name="brandGrossMargin">
        <search-form-template
          :searchOptions="brandGrossMarginSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelBrandGrossMargin()"
        ></search-form-template>
        <table-template ref="brandGrossMargin" :tableOptions="brandGrossMarginTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="日毛利" name="dayGrossMargin">
        <search-form-template
          :searchOptions="dayGrossMarginSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelDayGrossMarginTable()"
        ></search-form-template>
        <table-template ref="dayGrossMargin" :tableOptions="dayGrossMarginTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="分店销售毛利汇总" name="storeGrossMargin">
        <search-form-template
          :searchOptions="storeGrossMarginSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelStoreGrossMargin()"
        ></search-form-template>
        <table-template ref="storeGrossMargin" :tableOptions="storeGrossMarginTable"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate,
    },
    data() {
      return {
        activeTab: 'goodsGrossMargin',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },

        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print'
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          }
        ],

        // 商品毛利
        goodsGrossMarginSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'goodsGrossMarginName',
            isFuzzy: true,
            placeholder: '请输入商品名称/条码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll:true,
              span: 8,
              change: this.getSupplierChange,
              url: api.system.seStore
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              //url: api.archives.supplier,
              span: 8,
            },
            {
              label: "品牌",
              type: "select",
              prop: "goodsBrandId",
              data: [],
              span: 8
            },
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 8,
              url: api.archives.getCategoryTree,
            },
          ]
        },
        // //收银员对账
        categoryGrossMarginSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'categoryGrossMarginName',
            isFuzzy: true,
            placeholder: '请输入类别名称/编码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll:true,
              span: 8,
              url: api.system.seStore
            },
            {
              label: "类别",
              type: "cascader",
              prop: "goodsCategoryId",
              valueKey: 'value',
              data: [],
              span: 8,
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
          ]
        },
        // 品牌毛利
        brandGrossMarginSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'brandGrossMarginName',
            isFuzzy: true,
            placeholder: '请输入品牌名称/编码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll:true,
              span: 12,
              change: this.getBrandChange,
              url: api.system.seStore
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 8,
              //url: api.archives.brand
            },
          ]
        },
        // 收银日报（日期）
        dayGrossMarginSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'dayGrossMarginName',
            isFuzzy: true,
            placeholder: '请输入商品名称/条码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll:true,
              span: 8,
              url: api.system.seStore
            },
            {
              label: '条码',
              type: 'input',
              prop: 'barCode',
              span: 8,
              isFuzzy: true,
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              type: 'input',
              span: 8,
              isFuzzy: true,
            },
          ]
        },
        // 门店收银日报
        storeGrossMarginSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'storeGrossMarginName',
            isFuzzy: true,
            placeholder: '请输入门店名称'
          },],
          complex: [
            {
              label: '起止日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 8,
              isHasAll:true,
              url: api.system.seStore
            }
          ]
        },

        // 商品毛利
        goodsGrossMarginTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'purchasePrice', 'grossMarginMoney'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '160',
              align: 'center'
            },
            // {
            //   label: '门店编码',
            //   prop: 'storeCode',
            //   width: '100',
            //   align: 'center',
            // },
            {
              label: '单号',
              prop: 'billOrderNo',
              width: '240',
              align: 'center',
            },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '150',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '80',
              align: 'center',
            },
            {
              label: '单位',
              prop: 'goodsUnitName',
              width: '80',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '销售成本',
              prop: 'purchasePrice',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'grossMarginMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利率',
              prop: 'grossMargin',
              width: '100',
              align: 'center'
            },
            {
              label: '供应商',
              prop: 'supplierName',
              width: '150',
              align: 'center'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '150',
              align: 'center'
            },
            {
              label: '品牌',
              prop: 'goodsBrandName',
              width: '150',
              align: 'center'
            },
          ],
          param:{
            edCreateDttm:this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm:this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.goodsGrossMargin
        },
        //类别毛利
        categoryGrossMarginTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'purchasePrice', 'grossMarginMoney'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '120',
              align: 'center'
            },
            // {
            //   label: '门店编码',
            //   prop: 'storeCode',
            //   width: '100',
            //   align: 'center',
            // },
            {
              label: '类别名称',
              prop: 'goodsCategoryName',
              width: '100',
              align: 'center',
            },
            {
              label: '类别编码',
              prop: 'goodsCategoryCode',
              width: '100',
              align: 'center',
            },

            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '销售成本',
              prop: 'purchasePrice',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'grossMarginMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利率',
              prop: 'grossMargin',
              width: '100',
              align: 'center'
            },

          ],
          param:{
            edCreateDttm:this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm:this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.categoryGrossMargin
        },
        //品牌毛利
        brandGrossMarginTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'purchasePrice', 'grossMarginMoney'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '120',
              align: 'center'
            },
            // {
            //   label: '门店编码',
            //   prop: 'storeCode',
            //   width: '100',
            //   align: 'center',
            // },
            {
              label: '品牌名称',
              prop: 'goodsBrandName',
              width: '150',
              align: 'center',
            },
            {
              label: '品牌编码',
              prop: 'goodsBrandCode',
              width: '100',
              align: 'center',
            },

            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '销售成本',
              prop: 'purchasePrice',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'grossMarginMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利率',
              prop: 'grossMargin',
              width: '100',
              align: 'center'
            },
          ],
          param:{
            edCreateDttm:this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm:this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.brandGrossMargin
        },
        // 日毛利
        dayGrossMarginTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'purchasePrice', 'grossMarginMoney'],
          indexShow: true,//是否显示索引
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '120',
              align: 'center'
            },
            // {
            //   label: '门店编码',
            //   prop: 'storeCode',
            //   width: '100',
            //   align: 'center',
            // },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '150',
              align: 'center'
            },
            {
              label: '日期',
              prop: 'dayDate',
              width: '150',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '销售成本',
              prop: 'purchasePrice',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'grossMarginMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '毛利率',
              prop: 'grossMargin',
              width: '100',
              align: 'center'
            },

          ],
          url: api.retail.dayGrossMargin
        },
        // 分店销售毛利汇总
        storeGrossMarginTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'purchasePrice', 'grossMarginMoney'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '120',
              align: 'center'
            },
            // {
            //   label: '门店编码',
            //   prop: 'storeCode',
            //   width: '100',
            //   align: 'center',
            // },
            // {
            //   label: '条码',
            //   prop: 'barCode',
            //   width: '150',
            //   align: 'center'
            // },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '销售成本',
              prop: 'purchasePrice',
              width: '100',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'grossMarginMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '毛利率',
              prop: 'grossMargin',
              width: '100',
              align: 'center'
            },

          ],
          param:{
            edCreateDttm:this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm:this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.storeGrossMargin
        },

      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.goodsGrossMarginSearchOptions.complex);
      this.setStore(this.categoryGrossMarginSearchOptions.complex);
      this.setStore(this.brandGrossMarginSearchOptions.complex);
      this.setStore(this.dayGrossMarginSearchOptions.complex);
      this.setStore(this.storeGrossMarginSearchOptions.complex);
      this.getSupplierList();
      this.getBrandList();
    },
    mounted() {
    },
    methods: {
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange() {
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs['goodsGrossMargin'].clearSearch();
        this.$refs['categoryGrossMargin'].clearSearch();
        this.$refs['brandGrossMargin'].clearSearch();
        this.$refs['dayGrossMargin'].clearSearch();
        this.$refs['storeGrossMargin'].clearSearch();
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.brandGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
          this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        }
      },
      //获取供应商
      getSupplierChange(form) {
        form.supplierId = '';
        form.goodsBrandId = '';
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        })
      },
      getSupplierList() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.supplier + '/list', {}).then(data => {
            if (data.code === 200) {
              this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            }
          })
        }
      },
      //获取品牌
      getBrandList() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.brand + '/list', {}).then(data => {
            if (data.code === 200) {
              this.brandGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
              this.goodsGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            }
          })
        }
      },
      getBrandChange(form) {
        form.goodsBrandId = '';
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.brandGrossMarginSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        })
      },
      // 商品毛利
      exportExcelGoodsGrossMargin() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["goodsGrossMargin"].searchParam;
        this.$axios.PostBlob(api.retail.goodsGrossMarginExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '商品毛利_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 类别毛利
      exportExcelCategoryGrossMargin() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["categoryGrossMargin"].searchParam;
        this.$axios.PostBlob(api.retail.categoryGrossMarginExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '类别毛利_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 品牌毛利
      exportExcelBrandGrossMargin() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["brandGrossMargin"].searchParam;
        this.$axios.PostBlob(api.retail.brandGrossMarginExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '品牌毛利_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 日毛利
      exportExcelDayGrossMarginTable() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["dayGrossMargin"].searchParam;
        this.$axios.PostBlob(api.retail.dayGrossMarginExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '日毛利_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 分店销售汇总
      exportExcelStoreGrossMargin() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["storeGrossMargin"].searchParam;
        this.$axios.PostBlob(api.retail.storeGrossMarginExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '分店销售汇总_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
    }
  }
</script>

<style scoped>
.page-template{
  padding-top:0px;
}
</style>



// WEBPACK FOOTER //
// src/page/retail/query/profit/Analysis.vue